<template>
    <div id="main-wrap">
        <Alerts></Alerts>
        <vue3-progress />
        <router-view :key="$route.fullPath"></router-view>
        <BackPopup></BackPopup>

        <div class="chatra-button" :class="class_chatra_button" onclick="Chatra('openChat', true)">
            <span class="chatra-button__text">Hi! How can we help you today?</span>
            <span class="chatra-button__img"></span>
        </div>
    </div>
</template>

<script>
import BackPopup from '@/components/BackPopup.vue'
import Alerts from '@/components/Alerts.vue'
import Footer from '@/components/Footer.vue'
import fontAwesome from '@/styles/font-awesome.min.css'
import main from '@/styles/main.css'
import custom from '@/styles/custom.css'
import Chatra from '@chatra/chatra'
import config from '../config.js'

export default {
    components: {
        Footer,
        Alerts,
        BackPopup
    },
    mounted() {
        Chatra('init', {
            setup: {
                buttonSize: 55,
                buttonStyle: 'round',
                colors: {
                    buttonText: '#000', /* chat button text/icon color */
                    buttonBg: '#fff', /* chat button background color */
                    clientBubbleBg: '#000', /* visitor’s message bubble color */
                    agentBubbleBg: '#fff' /* agent’s message bubble color */
                }
            },
            ID: config.chatraId
        })

        let googletagmanagerSrcScript = document.createElement('script')
        googletagmanagerSrcScript.setAttribute('async', '')
        googletagmanagerSrcScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-75CE787N62')
        document.head.appendChild(googletagmanagerSrcScript)

        let googletagmanagerScript = document.createElement('script')
        googletagmanagerScript.textContent = "window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-75CE787N62');"
        document.head.appendChild(googletagmanagerScript)

        let googleAnaliticScript = document.createElement('script')
        googleAnaliticScript.textContent = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-TP328Z89');"
        document.head.appendChild(googleAnaliticScript)

        let noscript = document.createElement('noscript')
        let iframe = document.createElement('iframe')
        iframe.setAttribute('src', 'ns')
        iframe.setAttribute('height', '0')
        iframe.setAttribute('width', '0')
        iframe.setAttribute('style', 'display:none;visibility:hidden')
        noscript.appendChild(iframe)
        document.body.insertBefore(noscript, document.body.firstChild)

        this.$progress.finish();
    },
    created() {
        this.$progress.start();

        this.$router.beforeEach((to, from, next) => {

            this.$progress.start();
            next();
        });

        this.$router.afterEach((to, from) => {
            this.$progress.finish();
        });
    },
    computed: {
        class_chatra_button(){
            var val = 'near-button'

            if(['international', 'about', 'flatFeeTrademarkRegistrationPackage', 'trademarkFaqs', 'home', 'contactUs', 'privacyPolicy', 'termsOfUse', 'trademarkRegistrationProcess', 'trademarkRegistrationThankYou', 'trademark-office-action-desc', 'statement-of-use-desc', 'statement-of-use-extension-desc', 'trademark-renewal-desc', 'trademark-revival-desc', 'not-found'].indexOf(this.$route.name) != -1) {
                val = ''
            }

            return val
        }
    }
}
</script>

<style>
#chatra:not(.chatra--expanded) {
    visibility: hidden !important;
    opacity: 0 !important;
    pointer-events: none;
    transition: none;
}
#main-wrap {
    position: relative;
}

.chatra-button:hover {
    opacity: 0.9;
}
.chatra-button {
    position: fixed;
    right: 10px;
    cursor: pointer;
    display: flex;
    bottom: 10px;
    z-index: 999;
}
.chatra-button__text {
    background: white;
    display: block;
    border-radius: 18px;
    margin-right: 20px;
    position: relative;
    padding: 13px 30px;
    width: 173px;
    border: 1px solid black;
}
.chatra-button__text::before {
    position: absolute;
    content: '';
    display: block;
    width: 17px;
    height: 17px;
    background: white;
    transform: rotate(45deg);
    right: -9px;
    top: 31px;
    border-top: 1px solid black;
    border-right: 1px solid black;
}
.chatra-button__img {
    width: 75px;
    background-position: -17px 76px!important;
    background-size: cover!important;
    height: 75px;
    display: block;
    box-shadow: 0px 0px 2px 1px;
    border-radius: 50%;
    background: url(/public/images/dwqdqw.jpg);
}

@media (max-width: 768px){
    .chatra-button {
        display: none;
    }
}
</style>
